import {ACTION_BUTTON_Z_INDEX} from '../../ActionButtons';

const desktop = theme => {
  const {toVW} = theme;
  return {
    // '@keyframes darken': {
    //     '0%': {
    //         transform: 'scale(1)',
    //         filter: 'brightness(0.5)',
    //     },
    //     '50%': {
    //         transform: 'scale(1.2)',
    //         filter: 'brightness(0.5)',
    //     },
    //     '100%': {
    //         transform: 'scale(1)',
    //         filter: 'brightness(0.5)',
    //     },
    // },
    emojiButton: {
      zIndex: ACTION_BUTTON_Z_INDEX.SEND_EMOJI_BUTTON,
      cursor: 'pointer',
      position: 'absolute',
      top: -4,
      left: -7,
      transition: 'opacity 0.3s ease',
      minWidth: 23,
      height: 23,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&.ant-btn[disabled]': {
        background: '#200049',
        boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
        filter: 'brightness(0.4)',
      },
      '&:hover, &:active, &:focus': {
        // background: '#200049',
        // filter: 'brightness(0.8)',
      },
      // '&.darken': {
      //     animation: '$darken 1s infinite',
      // },
    },
    disabled: {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
  };
};
const mobile = theme => {
  const {toVW} = theme;
  return {
    emojiButton: {
      zIndex: ACTION_BUTTON_Z_INDEX.SEND_EMOJI_BUTTON,
      cursor: 'pointer',
      position: 'absolute',
      top: -4,
      left: -7,
      transition: 'opacity 0.3s ease',
      minWidth: 23,
      height: 23,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&.ant-btn[disabled]': {
        background: '#200049',
        boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
        filter: 'brightness(0.4)',
      },
      '&:hover, &:active, &:focus': {
        // background: '#200049',
        // filter: 'brightness(0.8)',
      },
      // '&.darken': {
      //     animation: '$darken 1s infinite',
      // },
    },
    disabled: {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
